export const ALERT = 'alert';
export const TIPS = 'tips';
export const PROMO_CODE = 'promoCode'
export const FEEDBACK = 'feedback';
export const ORDER_STATUS = 'orderStatus';
export const ORDER_TRACKING = 'orderTracking';
export const SELECT_PLATFORM = 'selectPlatform';
export const SELECT_BANK = 'selectBank';
